import { GET, POST, PUT, DELETE } from './api'

const prepareQs = (filters, pagination) => {
    return `${filters ? `&${filters}` : ``}${pagination ? `&${pagination}` : ``}`
}

export const Create = async (table, params) => {
    return await POST(`/${table}`, params, true);
}

export const Read = async (table, query = "?populate=*", pagination, filter) => {
    return await GET(`/${table}${query}${prepareQs(filter, pagination)}`, true);
}

export const ReadOne = async (table, id) => {
    return await GET(`/${table}/${id}?populate=*`, true);
}

export const Update = async (table, params, id) => {
    return await PUT(`/${table}/${id}`, params, true);
}

export const Delete = async (table, id) => {
    return await DELETE(`/${table}/${id}`, true);
}

